import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.element.addEventListener("submit", this.startLoading);
    this.element.addEventListener("turbo:submit-end", this.stopLoading);
  }

  disconnect() {
    this.element.removeEventListener("submit", this.startLoading);
    this.element.removeEventListener("turbo:submit-end", this.stopLoading);
  }

  startLoading = () => {
    this.loadingElement?.classList.add("--deleting");
  };

  stopLoading = () => {
    this.loadingElement?.classList.remove("--deleting");
  };

  get loadingElement() {
    return document.getElementById(this.element.dataset.deleteFileLoadingId);
  }
}
